import { render, staticRenderFns } from "./GlobalOptions.vue?vue&type=template&id=4b86f340&scoped=true&"
import script from "./GlobalOptions.vue?vue&type=script&lang=js&"
export * from "./GlobalOptions.vue?vue&type=script&lang=js&"
import style0 from "./GlobalOptions.vue?vue&type=style&index=0&id=4b86f340&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b86f340",
  null
  
)

export default component.exports